export default "__VITE_ASSET__0883b14a__"